import React, { useContext, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import ApplicationContext from "../../context/ApplicationContext";
import { adminUrl } from "../../EposConfig";

export interface ISettingsProps {
  close(): void;
  showOrderHistory(): void;
  showEndOfDay(): void;
  show: boolean;
}

export const SettingsModal: React.FC<ISettingsProps> = (
  props: ISettingsProps
): JSX.Element => {
  const context = useContext(ApplicationContext);

  function updateUsername(value: string) {
    window.localStorage.setItem("username", value.toString());
  }

  function updatePassword(value: string) {
    window.localStorage.setItem("password", value.toString());
  }

  const settingsModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => props.close()} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Setting</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group row">
              <label className="col-sm-2 col-form-label">Username</label>
              <div style={{ paddingLeft: 10 }}>
                <Form.Control
                  width={200}
                  aria-describedby="basic-addon1"
                  style={{ fontSize: "16px", width: "100%" }}
                  onChange={(e) => updateUsername(e.target.value)}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-2 col-form-label">Password</label>
              <div style={{ paddingLeft: 10 }}>
                <Form.Control
                  width={200}
                  aria-describedby="basic-addon1"
                  style={{ fontSize: "16px", width: "100%" }}
                  onChange={(e) => updatePassword(e.target.value)}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-2 col-form-label">Start Order No</label>
              <div style={{ paddingLeft: 10 }}>
                <Form.Control
                  width={200}
                  aria-describedby="basic-addon1"
                  style={{ fontSize: "16px", width: "100%" }}
                  onChange={(e) => setStartCount(e.target.value)}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="modal-footer">
            <Button
              variant="primary"
              style={{
                width: 150,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => props.showEndOfDay()}
            >
              EOD
            </Button>

            <Button
              variant="primary"
              style={{
                width: 150,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => totalRefresh()}
            >
              Refresh
            </Button>

            <Button
              variant="primary"
              style={{
                width: 150,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => orderHistory()}
            >
              Order History
            </Button>
            <Button
              variant="primary"
              style={{
                width: 100,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => admin()}
            >
              Admin
            </Button>
            <Button
              variant="success"
              style={{
                width: 150,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => props.close()}
            >
              Save & Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  function totalRefresh() {
    window.location.href = window.location.href;
  }

  function setStartCount(value: string) {
    context.Receipt.setReceiptNumber(Number(value));
  }

  function admin() {
    let url = context.Configuration.getSettings();
    window.location.replace(adminUrl);
  }

  function orderHistory() {
    props.showOrderHistory();
  }

  return (
    <>
      <>{settingsModal()}</>
    </>
  );
};
